import { useCallback } from "react";

import { useNotify } from "data/messages/hooks";

import useTemplateAction from "./useTemplateAction";
import useTemplateQuery from "./useTemplatesQuery";

export function useTemplates(section, redirect) {
  const notify = useNotify("WORKFLOWS_TEMPLATE");
  const result = useTemplateQuery(section);

  const [actionable, installing] = useTemplateAction(
    useCallback(
      (data) => {
        if (data?.workflows?.length > 0) notify(data.workflows);

        redirect();
      },
      [notify, redirect]
    )
  );

  const data = () => {
    return result.data.map(actionable);
  };

  return { ...result, data, installing };
}

export default useTemplates;
